import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewportDevice } from '@zep/react';
import { Button } from '@zep/ui';
import S from './PricingEducation.module.scss';
// 로컬 작업 불필요
export const PricingEducation = () => {
  const {
    locale
  } = useRouter();
  const {
    t
  } = useTranslation(['subscription'], {
    useSuspense: true
  });
  const {
    isMobile
  } = useViewportDevice();
  if (locale !== 'ko') return;
  return <section className={S.section} data-sentry-component="PricingEducation" data-sentry-source-file="PricingEducation.tsx">
      <div className={S.inner}>
        <div className={S.banner}>
          <div className={S.left}>
            <h2 className={S.title}>
              {t('subscription:pricing.education.title')}
            </h2>
            <p className={S.description}>
              {t('subscription:pricing.education.description')}
            </p>
            <div className={S.button}>
              <Button as="a" size={isMobile ? 'sm' : 'md'} href={t('subscription:pricing.education.buttonLink')} onClick={() => logger.track('home_pricing_edu_plan')} target="_blank" data-sentry-element="Button" data-sentry-source-file="PricingEducation.tsx">
                {t('subscription:pricing.education.buttonText')}
              </Button>
            </div>
          </div>
          <div className={S.right}>
            <div className={S.img}>
              <img src="/images/pricing/edu-teacher.png" alt="" width={186} height={136} />
            </div>
          </div>
        </div>
      </div>
    </section>;
};